import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GbGemeindeId, GbgrundstueckService, GrundstueckId } from 'app/core/gb-api';
import { TimepointService } from 'app/core/services/timepoint.service';
import { AppConfigService } from 'app/core/services/app-config.service';
import {
  AmtlichebewertungNeskoService,
  FieldMetaData,
  NeskoAbAmtlicherWertDetailEntryMeta,
  NeskoAbDetailEntryMeta
} from 'app/core/amtlichebewertung-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { map, share } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { ListLoaderObservable } from 'app/shared/components/list-loader/list-loader-observable';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ActivatedRoute, Router } from '@angular/router';
import { ListLoaderWrapperComponent } from '../../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { NeskoabGrundstueckEigentumComponent } from '../../../../neskoab/neskoab-detail/neskoab-grundstueck-eigentum/neskoab-grundstueck-eigentum.component';
import { NeskoabPersonenEigentumComponent } from '../../../../neskoab/neskoab-detail/neskoab-personen-eigentum/neskoab-personen-eigentum.component';
import { CapAlertComponent } from '../../../../core/extension/exceptions/cap-alert.component';
import { BetragPipe } from '../../../../shared/pipes/simple/betrag.pipe';
import { DecimalHochkommaPipe } from '../../../../shared/pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-neskoab-rubrik-uebersicht',
  templateUrl: './neskoab-rubrik-uebersicht.component.html',
  styleUrls: ['./neskoab-rubrik-uebersicht.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    NeskoabGrundstueckEigentumComponent,
    NeskoabPersonenEigentumComponent,
    CapAlertComponent,
    TranslatePipe,
    BetragPipe,
    DecimalHochkommaPipe
  ]
})
export class NeskoabRubrikUebersichtComponent extends AbstractComponent implements OnInit, OnChanges {
  neskoEntry: NeskoAbDetailEntryMeta;

  neskoServiceVerfuegbar = true;

  listLoader: ListLoader<NeskoAbAmtlicherWertDetailEntryMeta>;

  @Input()
  public gsId: GrundstueckId;

  constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router,
    private neskoAbService: AmtlichebewertungNeskoService,
    private translate: TranslateService
  ) {
    super();
    keysToTranslate<string>(['neskoab.nichtVerfuegbar', 'gemaessAmtlicherBewertung']);
  }

  get hasRightVerteiler(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mVerteiler.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightEigentum(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mEigentum.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  ngOnInit() {
    this.addSub(
      this.translate.onLangChange.subscribe(() => {
        this.init();
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.gsId.currentValue) {
      return;
    }
    this.init();
  }

  init() {
    this.listLoader = null;
    const temp: Observable<NeskoAbDetailEntryMeta> = this.loadData().pipe(share());
    this.createListLoader(temp);
    this.addSub(
      temp.subscribe({
        next: (n) => {
          this.neskoEntry = n;
        },
        error: (err) => this.handleError(err)
      })
    );
  }

  createListLoader(nesko: Observable<NeskoAbDetailEntryMeta>) {
    this.addSub(
      nesko
        .pipe(
          map((n) => {
            if (n.amtlicherWert) {
              return [n.amtlicherWert];
            }
            return [];
          })
        )
        .subscribe({
          next: (result) => {
            this.listLoader = new ListLoaderObservable<NeskoAbAmtlicherWertDetailEntryMeta>(undefined, undefined, of(result));
          },
          error: (err) => this.handleError(err)
        })
    );
  }

  handleError(err: any) {
    if (err.status === 502) {
      this.neskoServiceVerfuegbar = false;
      return;
    } else if (err.status === 404) {
      return;
    } else if (err.status === 403) {
      return;
    }
    throw err;
  }

  getGemeindeId(id: string): GbGemeindeId {
    return { id };
  }

  private loadData(): Observable<NeskoAbDetailEntryMeta> {
    this.neskoServiceVerfuegbar = true;
    if (!this.gsId || !this.gsId.id) {
      return EMPTY;
    }
    return this.neskoAbService.loadSichtByGrundstueckNummer(
      null, //
      null, //
      null, //
      null, //
      this.gsId.id, //
      this.translate.currentLang
    );
  }
}
